var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function asyncFetch(url, options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(url, options);
            const status = response.status;
            const ok = response.ok;
            const contentType = response.headers.get('content-type');
            return {
                ok,
                status,
                contentType,
                body: response.body,
            };
        }
        catch (e) {
            return {
                status: 500,
                ok: false,
                body: undefined,
                contentType: null,
                error: e.message,
            };
        }
    });
}
